import Image from 'next/image';
import type { ReactElement } from 'react';

import {
  AvatarWrapper,
  Header,
  StoryHighlight,
  StoryText,
  StoryTitle,
  Wrapper,
} from './Story.styled';

export const Story = (): ReactElement => (
  <Wrapper>
    <Header>
      <AvatarWrapper>
        <Image
          src="/static/images/teneryfa/portrait.jpg"
          alt="Magda, autorka przewodnika po Teneryfie."
          fill
          sizes="(max-width: 768px) 96px, 120px"
          style={{ objectFit: 'cover' }}
        />
      </AvatarWrapper>
      <StoryTitle>Skąd pomysł na ten przewodnik?</StoryTitle>
    </Header>
    <StoryText>
      Od 8 lat prowadzę bloga i publikuję posty z praktycznymi wskazówkami.
      Kiedy wyjechałam kolejny raz na Teneryfę, aby tam trochę pomieszkać,
      szybko zorientowałam się, że{' '}
      <StoryHighlight>
        mam zdecydowanie za dużo wiedzy i&nbsp;materiału, by zmieścić to na
        blogu.
      </StoryHighlight>{' '}
      Tak narodził się pomysł. A forma? Miałam okazję niejednokrotnie czytać
      przewodniki z innych miejsc od różnych twórców i wiedziałam co chcę zrobić
      inaczej, na czym mi najbardziej zależy, gdy podróżuję.{' '}
      <StoryHighlight>
        Stąd za cel postawiłam sobie, że będzie to praktyczny przewodnik, ze
        sprawdzonymi wskazówkami, dla osób, które tak jak ja, lubią maksymalnie
        wykorzystać czas na miejscu.
      </StoryHighlight>
    </StoryText>
  </Wrapper>
);
